<template>
    <div>
        <v-text-field
            :model-value="localValue ? $moment(localValue, localFormat).format(localDisplayFormat) : ''"
            :label="label"
            :append-inner-icon="clearable && localValue ? 'clear' : ''"
            :disabled="disabled"
            :error-messages="errorMessages"
            :rules="rules"
            :hide-details="hideDetails"
            :id="id"
            type="button"
            @click="dialog = true"
            @click:appendInner="localValue = null"
            @blur="$emit('blur')"
        ></v-text-field>
        <date-picker
            :editable="true"
            :jumpMinute="jumpMinute"
            :roundMinute="roundMinute"
            :show="dialog"
            :format="localFormat"
            :type="type"
            :min="localMin"
            :max="localMax"
            :element="id"
            v-model="localValue"
            @close="dialog = false"
        ></date-picker>
    </div>
</template>
<script>
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";
export default {
    components: {
        DatePicker: Vue3PersianDatetimePicker
    },
    props: {
        modelValue: {
            required: true,
            default: null
        },
        label: {
            type: String,
            default: 'تاریخ...'
        },
        type: {
            type: String,
            default: 'datetime'
        },
        format: {
            type: String,
            default: ''
        },
        displayFormat: {
            type: String,
            default: ''
        },
        disabled: {
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false
        },
        roundMinute: {
            default: false
        },
        min: {
            default: null
        },
        max: {
            default: null
        },
        jumpMinute: {
            default: 0
        },
        hideDetails: {
            default: false
        },
        errorMessages: {
            default: () => []
        },
        rules: {
            default: () => []
        },
    },
    data() {
        return {
            dialog: false,
        }
    },
    setup() {
        const id = useId();
        return { id };
    },
    computed: {
        localValue: {
            get: function () {
                if (!this.modelValue)
                    return null;
                if (/^\d+$/.test(this.modelValue))
                    return this.$moment(this.modelValue, 'X').format(this.localFormat);
                let value = this.$moment(this.modelValue);
                this.$emit('update:modelValue', value.format('X'));
                return value.format(this.localFormat);
            },
            set: function (value) {this.$emit('update:modelValue', value ? this.$moment(value, this.localFormat).format('X') : null)}
        },
        localMin() {
            return this.min ? this.$moment(this.min, /^\d+$/.test(this.min) ? 'X' : false).format(this.localFormat) : null;
        },
        localMax() {
            return this.max ? this.$moment(this.max, /^\d+$/.test(this.max) ? 'X' : false).format(this.localFormat) : null;
        },
        localFormat() {
            if (this.format)
                return this.format;
            return this.type == 'time' ? 'HH:mm' : this.type == 'datetime' ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
        },
        localDisplayFormat() {
            if (this.displayFormat)
                return this.displayFormat;
            return this.type == 'time' ? 'HH:mm' : this.type == 'datetime' ? 'HH:mm jYYYY/jMM/jDD' : 'jYYYY/jMM/jDD';
        }
    },
}
</script>
